import { FivSpinner } from './spinner.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [FivSpinner],
  imports: [CommonModule],
  exports: [FivSpinner]
})
export class FivSpinnerModule {}
